var exports = {
  "Qs": "DebugModal.module__content___eU9XNU",
  "kL": "DebugModal.module__container___eU9XNU",
  "sN": "DebugModal.module__tabsSection___eU9XNU",
  "vR": "DebugModal.module__tabs___eU9XNU",
  "P1": "DebugModal.module__scrollArea___eU9XNU",
  "z": "DebugModal.module__summary___eU9XNU",
  "hZ": "DebugModal.module__summaryTitle___eU9XNU",
  "D_": "DebugModal.module__summaryBody___eU9XNU",
  "Ip": "DebugModal.module__summaryItem___eU9XNU",
  "rG": "DebugModal.module__summaryLabel___eU9XNU",
  "Qb": "DebugModal.module__summaryValue___eU9XNU",
  "ZP": "DebugModal.module__codeSection___eU9XNU",
  "Dy": "DebugModal.module__codeSurface___eU9XNU",
};

module.exports = exports;
